import { Modal } from 'react-bootstrap';
import { ReactComponent as Success } from '../../Assets/img/Success.svg';
import { ReactComponent as TickWhite } from '../../Assets/img/TickWhite.svg';

function MessagePopup(props) {
    return (
        <Modal centered={true} contentClassName="message-popup-container" show={true} onHide={props.onClose}>
            <Modal.Header className="message-popup-container-header" closeButton><Success />
                <Modal.Title className="message-popup-title">{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.body}
            </Modal.Body>
            <Modal.Footer className="message-popup-container-footer">
                <button type="submit" className="primary-button" onClick={props.onClose}>
                    <span className="primary-button-icon"><TickWhite /></span>
                    <span className="primary-button-text">OK</span>
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default MessagePopup;